export default __webpack_public_path__ + "static/media/sza.cbe88353.jpeg";